import { jsx as _jsx } from "react/jsx-runtime";
import { Route, Routes } from "react-router-dom";
import { useHasModuleAccess } from "@advosys/component-advosys-react";
import { Modules } from "@advosys/component-app-server-client-js";
import { ModuleAccessError } from "src/core";
import { DynamicInvoicePagesRoutes } from "./pages/dynamic-invoice-page";
export const DynamicInvoiceRoutes = () => {
    const moduleAccess = useHasModuleAccess(Modules.uamaDynamiskFaktureringAdgang);
    if (!moduleAccess)
        return _jsx(ModuleAccessError, {});
    return (_jsx(Routes, { children: _jsx(Route, { path: "*", element: _jsx(DynamicInvoicePagesRoutes, {}) }) }));
};
